import { render } from "./picker.vue?vue&type=template&id=5683796f"
import script from "./picker.vue?vue&type=script&lang=js"
export * from "./picker.vue?vue&type=script&lang=js"

import "./picker.vue?vue&type=style&index=0&id=5683796f&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/m-picker/picker.vue'],['render',render],['__file',"picker.vue"]])

export default __exports__